import React, { Component } from "react";

class Footer extends Component {
  render() {
    const currentYear = new Date().getFullYear();

    return (
      <footer className="footer py-3">
        <h4>
          Pickaxe{" "}
          <span className="text-info">
            {" "}
            <span className="footer__intel">Data Intelligence</span>
          </span>{" "}
        </h4>

        <div className="row mt-3">
          <div className="col-sm-12 footer_copyrights">
            &copy; Pickaxe {currentYear}
          </div>
        </div>
      </footer>
    );
  }
}

export default Footer;
